import { logCSAUserAction } from '../../utils/logUserAction';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { createAppButton } from 'owa-command-ribbon';
import { RIBBON_OPENED_SOURCE } from 'owa-expressions-store/lib/store/schema/ExpressionPickerOpenedSource';
import isExpressionPaneOpen from 'owa-expressions-store/lib/utils/isExpressionPaneOpen';
import { lazyToggleExpressionPane } from 'owa-expressions-view';
import EmojiRegular from 'owa-fluent-icons-svg/lib/icons/EmojiRegular';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import type { IButtonStyles } from '@fluentui/react';
import { ActionControlId } from 'owa-ribbon-ids';
import loc from 'owa-localize';
import { emojiText } from '../../utils/actionControlStrings.locstring.json';
import { getHoverTooltip } from '../../utils/HoverTooltips/getHoverTooltip';
import { callEditorApi } from 'owa-editor/lib/utils/callEditorApi';

const onToggleExpressionPicker = computedFn(
    (viewState: EditorViewState | undefined, expressionId: string) => {
        const key = 'AddEmoji';
        return () => {
            if (viewState) {
                const shouldShowExpressionPane = !isExpressionPaneOpen(expressionId);

                lazyToggleExpressionPane.import().then(toggleExpressionPane => {
                    const targetWindow =
                        callEditorApi(viewState, 'getDocument')?.defaultView || window;
                    toggleExpressionPane(
                        shouldShowExpressionPane,
                        true /* useFlexPane */,
                        RIBBON_OPENED_SOURCE,
                        viewState,
                        expressionId,
                        targetWindow
                    );
                });

                logCSAUserAction(key, { key }, !shouldShowExpressionPane ? 'Close' : 'Open');
            }
        };
    }
);

export const getAddEmoji = computedFn(
    (
        viewState: EditorViewState,
        expressionId: string,
        styles: IButtonStyles | undefined
    ): RibbonControlProps => {
        const label = loc(emojiText);
        return createAppButton(
            getComposeRibbonId(ActionControlId.Emoji, viewState),
            label,
            onToggleExpressionPicker(viewState, expressionId),
            undefined /* keytipProps */,
            EmojiRegular,
            undefined /* iconColor */,
            styles,
            {
                customTooltip: getHoverTooltip(ActionControlId.Emoji, label),
            }
        );
    }
);
